import React from 'react';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { styled } from '@mui/material/styles';

const OWN_PROPS = ['isSelected', 'isHovered', 'isStart', 'isEnd', 'isOutOfLimit'];

// A range reads as one band: the days between the ends on the primary tint
// with its text colour, the two ends solid primary and rounded on the outside.
// The inner days used to be primary.light under white text, 2.4:1.
const CustomPickersDay = styled(PickersDay, {
    shouldForwardProp: (prop) => !OWN_PROPS.includes(prop),
})(({ theme, isSelected, isHovered, isStart, isEnd, isOutOfLimit }) => ({
    borderRadius: 0,
    ...(isSelected && {
        // No gap between the tiles of a range.
        width: 40,
        margin: 0,
    }),
    ...(isOutOfLimit && {
        "backgroundColor": theme.palette.action.disabledBackground,
        "color": theme.palette.text.disabled,
        "&:hover, &:focus": {
            backgroundColor: theme.palette.action.disabledBackground,
        },
    }),
    ...(isHovered && {
        "backgroundColor": theme.palette.primary.tint12,
        "color": theme.palette.primary.softText,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.tint18,
        },
    }),
    ...((isStart || isEnd) && {
        "backgroundColor": theme.palette.primary.main,
        "color": theme.palette.primary.contrastText,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.hover,
        },
    }),
    ...(isStart && {
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
    }),
    ...(isEnd && {
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
    }),
}));

export const Day = (props) => {
    const { startDate, endDate, day, limit, ...other } = props;
    const isSelected = day.isBetween(startDate, endDate, 'day', '[]');
    const isHovered = day.isBetween(startDate, endDate, 'day', '()');
    const isStart = Boolean(startDate) && day.isSame(startDate, 'day');
    const isEnd = Boolean(endDate) && day.isSame(endDate, 'day');

    // disable selection for days outside the limit
    // limit is a number of days before and after the startDate

    const isValidStart = startDate && startDate.isValid() && limit && limit > 0;

    const maxDate = isValidStart ? startDate.clone().add(limit - 1, 'day') : null;

    const isOutOfLimit = day.isAfter(maxDate);

    return (
        <CustomPickersDay
            isSelected={isSelected}
            isHovered={isHovered}
            isStart={isStart}
            isEnd={isEnd}
            disabled={isOutOfLimit}
            isOutOfLimit={isOutOfLimit}
            day={day}
            {...other}
        />
    );
};
